"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HierarchicalDrillDownItems = /** @class */ (function () {
    /**
     * @param {Array<ClassifierView>} data
     */
    function HierarchicalDrillDownItems(data) {
        this.data = data;
    }
    HierarchicalDrillDownItems.prototype.getFirstItem = function () {
        return this.data !== undefined &&
            this.data !== null &&
            this.data.length > 0
            ? this.data[0]
            : null;
    };
    HierarchicalDrillDownItems.prototype.getNextItem = function (currentHierarchicalItem) {
        var index = this.data.indexOf(currentHierarchicalItem);
        return index !== null && index >= 0 ? this.data[index + 1] : null;
    };
    HierarchicalDrillDownItems.prototype.getPreviousItem = function (currentHierarchicalItem) {
        var index = this.data.indexOf(currentHierarchicalItem);
        return index !== null && index >= 0 ? this.data[index - 1] : null;
    };
    return HierarchicalDrillDownItems;
}());
exports.HierarchicalDrillDownItems = HierarchicalDrillDownItems;
//# sourceMappingURL=hierarchical-drillDown-items.model.js.map